<template>
  <div class="scene signup flex-r">
    <div class="section size-50" />

    <div id="step-container" class="size-40">
      <div class="signup-form-bg shadow-large">
        <h1>
          Готово
        </h1>

        <div class="signup-form-buttons flex-r">
          <div class="section size-100 txt-algn-r">
            <div
              class="button primary"
              @click="emitNextStepEvent"
            >
              <div class="text">
                Завершить
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section size-10" />
  </div>
</template>

<script>
export default {
  name: 'DoneStep',
  methods: {
    emitNextStepEvent() {
      window.location = this.$generateAbsolutePath('/');
    }
  }
}
</script>
